<template>
  <div>
    <loading :active.sync="isLoading" color="#64B9B0"></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
         <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/adm_empresa/unidades">Unidades</router-link>
          </li>
          <li class="breadcrumb-item active">Detalhes da Unidade</li>
        </ol>

        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2>
              <i class="fa fa-info-circle"></i>Informações da Unidade
            </h2>
          </div>

          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Nome da Unidade</label>
                <input
                  readonly
                  type="text"
                  class="form-control"
                  v-model="unidade.nome_unidade"
                />
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>Vínculo</label>
                <v-select
                  disabled
                  label="nome_empresa"
                  class="form-select"
                  v-model="unidade.empresas_id"
                  :reduce="empresas => empresas.id"
                  :options="empresas"
                  :searchable="true"
                >
                </v-select>
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>CEP</label>
                <input
                  readonly
                  type="text"
                  class="form-control"
                  v-mask="['#####-###']"
                  v-model="unidade.CEP"
                />
              </div>
            </div>

          </div>

          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Logradouro</label>
                <input
                  readonly
                  class="form-control"
                  v-model="unidade.logradouro"
                  type="text"
                />
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>Bairro</label>
                <input
                  readonly
                  class="form-control"
                  v-model="unidade.bairro"
                  type="text"
                />
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>Número</label>
                <input
                  readonly
                  class="form-control"
                  v-model="unidade.numero"
                  type="number"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { tratamento_requisicao } from "@/utils/util";
import funcoesGerais from "@/assets/js/funcoes.js";
import axios from 'axios'

export default {
  mixins: [funcoesGerais],
  data() {
    return {
      id_unidade: this.$route.params.id_unidade,
      unidade: {},
      empresas: [],
      search: "",
			isLoading: false
    };
  },
  mounted() {
    let self = this;
    self.isLoading = true;
    axios.all([
      axios.get('empresas'),
      axios.get(`unidades/${self.id_unidade}`)
    ])
      .then(axios.spread((resEmpresas, resUnidade) => {
        self.empresas = resEmpresas.data;
        self.unidade = resUnidade.data
        self.isLoading = false;

      }, err => {
        self.isLoading = false;
        tratamento_requisicao(err);
      }))
  },
  methods: {

  }
};
</script>

<style>

.img {
  display: flex;
  align-items: center;
}

</style>
